import { nextMonday } from 'date-fns';
var MARATHON_VISITED = 'hn-marathon-visited';
export var setVisited = function () { return localStorage.setItem(MARATHON_VISITED, '1'); };
export var getVisited = function () { return localStorage.getItem(MARATHON_VISITED); };
export var nextWeekDate = nextMonday(new Date());
export var formatPoints = new Intl.NumberFormat('en-US').format;
